import React from "react";

import { Form } from "antd";

interface FormItemWrapperProps {
    helpText?: string;
    error?: string;
    warning?: string;
    children: React.ReactNode;
    label?: React.ReactNode;
    required?: boolean;
}

const FormItemWrapper: React.FC<FormItemWrapperProps> = ({
    helpText,
    error,
    warning,
    children,
    label,
    required,
}) => (
    <Form.Item
        validateStatus={error ? "error" : warning ? "warning" : "success"}
        help={error ? error : warning ? warning : helpText ? helpText : ""}
        style={{
            width: "100%",
            paddingBottom: "8px",
            marginBottom: (error || warning || helpText) ? "18px" : "8px",
        }}
        label={
            label ? (
                <div>
                    {label}
                    {required && <span style={{ color: "red" }}> *</span>}
                </div>
            ) : null
        }
        required={required}
    >
        {children}
    </Form.Item>
);

export default FormItemWrapper;
